import { render } from "./CandidateActionLayout.vue?vue&type=template&id=315ec24d"
import script from "./CandidateActionLayout.vue?vue&type=script&lang=js"
export * from "./CandidateActionLayout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__